<template>
<div>
    <v-list>
        <v-list-item
            v-for="(integration, index) in integrations"
            :key="index"
            v-on:click="onClickIntegration(integration)"
        >
            <v-list-item-avatar>
                <v-icon
                    :class="{ 'int-disabled' : !integration.enabled, 'int-error' : integration.error }"
                >
                    {{integration.icon}}
                </v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
                <v-list-item-title
                    :class="{ 'int-disabled' : !integration.enabled, 'int-error' : integration.error }"
                >
                    {{integration.label}}
                </v-list-item-title>

                 <v-list-item-subtitle
                    v-if="integration.brand_label != null"
                >
                    Brand label: {{integration.brand_label}}
                </v-list-item-subtitle>

                <v-list-item-subtitle
                    v-if="integration.tenant != null && integration.type != 'mailchimp'"
                >
                    Tenant: {{integration.tenant}}
                </v-list-item-subtitle>

                <v-list-item-subtitle
                    v-if="integration.username != null && integration.type != 'mailchimp'"
                >
                    Username: {{integration.username}}
                </v-list-item-subtitle>

                <v-list-item-subtitle
                    :class="{ 'int-disabled' : !integration.enabled, 'int-error' : integration.error  }"
                >
                    {{integration.sub_label}}
                </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
                <v-menu 
                    bottom 
                    offset-y  
                >
                    <template v-slot:activator="{ on }">
                        <v-icon 
                            v-on="on"
                        >
                            mdi-dots-vertical
                        </v-icon>
                        
                    </template>

                    <v-list>
                        <v-list-item
                            v-for="(item, menu_item_index) in integration.actions"
                            :key="menu_item_index"
                            v-on:click="item.action(integration)"
                        >
                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                        </v-list-item>
                    </v-list>

                </v-menu> 
            </v-list-item-action>
        </v-list-item>
    </v-list>

   <m-adf-settings-dialog
    ref="adf-settings-dialog"
    v-on:ok="$emit('reload')"
   />

   <m-dialog-crm-settings
    ref="crm-settings-dialog"
    v-on:ok="$emit('reload')"
   />

    <m-icon-bar
        v-on:add="onClickAddIntegration"
        v-on:features="onClickFeatures"
    />

    <m-integration-features-dialog
        ref="features-dialog"
    />

</div>
</template>

<script>
const Time = require('@/js/time.js');
export default {
    props: {
        profile: {
            type: Object,
            default: function() { return {}; },
        },
    },
    
    methods: {
        onEditAdf(integration) {
            if ( this.preventSandboxEdit() ) return;

            this.$refs['adf-settings-dialog'].showDialog(integration.settings);
        },

        onDelteAdf(integration) {
            this.$rc.confirm(
                'Confirm Delete Integration: '+integration.settings.system_label,
                'This integration will be permenantly delted.',
                [
                    {'text' : 'Cancel', 'value' : 'cancel' },
                    {'text' : 'Delete', 'value' : 'confirmed' },
                ],

                (response) => {
                    if ( response != 'confirmed' ) return;
                    
                    this.$rc.showSpinner();

                    this.$rc.deleteAdfIntegration(
                        integration.settings.integration_id,

                        () => {
                            this.$rc.hideSpinner();
                            this.$rc.snackbar('Integration deleted');
                            this.$emit('reload');
                        },

                        () => {
                            this.$rc.hideSpinner();
                            this.$rc.alert('Error','Unable to delete integration');
                        }
                    );
                }
            );
        },

        onNewIntegrationAdf()
        {
            let adf_dialog = this.$refs['adf-settings-dialog'];

            adf_dialog.showDialog(
                adf_dialog.createNew(this.profile.organization_id)
            );
        },

        preventSandboxEdit()
        {
            if ( !this.profile.organization_account.is_sandbox_organization ) return false;
            if ( this.$rc.$state.isAuthActorSystemAdmin() ) return false;

            this.$rc.alert('Sandbox accounts may not change their integrations', 'Your organizaiton has a sandbox account.  In a sandbox account you can not edit integrations.');
            return true;
        },

        onEditCRMSettings(integration)
        {
            if ( this.preventSandboxEdit() ) return;

            this.$refs['crm-settings-dialog'].showDialog(integration);
        },

        onClickAddIntegration()
        {
            if ( this.preventSandboxEdit() ) return;

            let choices = this.$rc.enumChoices('integration_name', false);

            choices.push({
                'text': 'ADF',
                'value': 'adf'
            });

            choices = choices.filter((el) => { return el.value != 'manual'; })
            choices = choices.filter((el) => { return el.value != 'calendly'; })

            choices.sort((a,b) => { return a.text.localeCompare(b.text); });

            this.$rc.promptSelect({
                'title': 'Add integration',
                'label': 'Integration',
                'items': choices,
                'after_prompt': (value) => 
                {
                    this.onAddIntegration(value);
                }
            });
        },

        onClickFeatures()
        {
            let choices = this.$rc.enumChoices('integration_name', false);

            choices = choices.filter((el) => { return el.value != 'manual'; })
            choices = choices.filter((el) => { return el.value != 'calendly'; })

            choices.sort((a,b) => { return a.text.localeCompare(b.text); });

             this.$rc.promptSelect({
                'title': 'View features of integration',
                'label': 'Integration',
                'items': choices,
                'after_prompt': (value) => 
                {
                    this.$refs['features-dialog'].showDialog(value);
                }
            });
        },

        onAddIntegration(value)
        {
            if ( value == null ) return;

            if ( value == 'adf' )
            {
                this.onNewIntegrationAdf();
                return;
            }

            this.$rc.showSpinner();
            
            this.$rc.rest(
                'PATCH: /api/v1/integrations/crm/settings',
            
                {
                    'organization_id': this.profile.organization_id,
                    'content_type': value,
                    'settings_id': this.$rc.uuidv4(),
                },
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.$emit('reload');
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to create new integration');
                },
            );
        },

        onClickIntegration(integration)
        {
            for ( let i = 0; i < integration.actions.length; i++ )
            {
                if ( integration.actions[i].text == 'Edit...' )
                {
                    integration.actions[i].action(integration);
                }
            }
        },

        startDeepSync(integration_settings)
        {
            this.$rc.confirm({
                'title': 'Start Deep Sync',
                'body': 'A deep sync begins by deleting all information (customers, orders, etc.) presently associated with any '+integration_settings.content_type+' integration.<br/><br/>Once the deep delete is complete, a full sync is started. There may be a significant delay before the sync starts.',
                'btn_text_ok': 'Start Deep Sync',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                     let params = {
                        'type': 'crm-start-deep-sync',
                        'params': {
                            'organization_id': integration_settings.organization_id,
                            'content_types': [integration_settings.content_type],
                        },

                        status: (pte) => {
                            if ( pte.state == 'failed' )
                                return "Unable to begin deep sync (probably because a sync is currently running)";

                            return 'Deleting all existing data in organization created by '+integration_settings.content_type;
                        },

                        'title': 'Starting Deep Sync '+integration_settings.content_type,
                        'finished_button_text': 'Ok',
                        'failed_button_text': 'Ok',

                         on_finished: (pte) => {
                                this.$emit('reload');
                            },
                        
                            on_failed: (pte) => {
                                this.$emit('reload');
                            },
                    };

                    this.$rc.startProcess(params);
                },
            });

           
        },
    },

    computed: {

        integrations() 
        {
            let ret = [];

            if ( this.profile == null ) return ret;

            // ADF
            let adf_integrations = this.profile.integration_settings.adf_integrations;
            for ( let i = 0; i < adf_integrations.length; i++ )
            {
                ret.push({
                    'settings' : adf_integrations[i],
                    'integration_id': adf_integrations[i].integration_id,
                    'type' : 'adf',
                    'icon' : 'mdi-folder-account-outline',
                    'label' : adf_integrations[i].system_label,
                    'sub_label' : 'ADF CRM Integration',
                    'enabled' : true,

                    'actions' : [
                        { 'text' : 'Edit...', 'action' : this.onEditAdf },
                        { 'text' : 'Delete', 'action' : this.onDelteAdf },
                    ],
                });
            }

            for ( let i = 0; i < this.profile.integration_crm_summaries.length; i++ )
            {
                let settings = this.profile.integration_crm_summaries[i];

                let supports = this.$rc.enumObject('integration_name',settings.content_type).supports;


                if ( settings.content_type == 'fare-harbor' )
                    continue;

                let label = this.$rc.pretty(settings.content_type,'integration_name');
                let sub_title = settings.enabled ? 'Will synchronize in 5 minutes or less' : '';

                if ( !supports.includes('sync') )
                    sub_title = '';

                let items = [];

                if ( settings.last_fs_cur_state != null ) items.push("Last Sync: "+settings.last_fs_cur_state);
                if ( settings.last_fs_count_customer != null && settings.content_type != 'mailchimp' && settings.content_type != 'wine-direct-fulfillment' ) items.push("customers: "+settings.last_fs_count_customer);
                if ( settings.last_fs_count_order != null && settings.content_type != 'mailchimp' && settings.content_type != 'wine-direct-fulfillment' ) items.push("orders: "+settings.last_fs_count_order);
                if ( settings.last_fs_count_reservation != null && settings.content_type != 'mailchimp' && settings.content_type != 'wine-direct-fulfillment'  ) items.push("reservations: "+settings.last_fs_count_reservation);

                if ( settings.last_fs_count_crm_email_campaign != null && settings.content_type != 'wine-direct-fulfillment' ) items.push("email campaigns: "+settings.last_fs_count_crm_email_campaign);

                if ( settings.last_fs_time_start != null  && settings.content_type != 'wine-direct-fulfillment' ) items.push("start time: "+Time.getTimeAndDate(settings.last_fs_time_start));
                if ( settings.last_fs_time_stop != null  && settings.content_type != 'wine-direct-fulfillment' ) items.push("finish time: "+Time.getTimeAndDate(settings.last_fs_time_stop));

                if ( settings.content_type == 'wine-shipping' )
                {
                    items = [];

                    if ( settings.last_fs_count_shipping_event != null )
                    {
                        items.push('Shipping events received: '+settings.last_fs_count_shipping_event);
                    }
                }
                
                if ( items.length > 0 )
                    sub_title = this.$rc.pretty(items, 'comma_list');

                let el = {
                    'settings' : {},
                    'integration_id': settings.content_type,
                    'type' : settings.content_type,
                    'icon' : 'mdi-folder-account-outline',
                    'label' : label,
                    'sub_label' : sub_title,
                    'enabled' : settings.enabled,
                    'error' : null,
                    'tenant': settings.tenant,
                    'username': settings.username,
                    'brand_label': settings.brand_label,

                    'actions' : [
                        { 'text' : 'Edit...', 'action' : () => { this.onEditCRMSettings(settings); } },
                    ],
                };

                if ( this.$rc.integrationSupports(settings.content_type, 'sync') )
                {
                    el.actions.push({ 'text' : 'Refresh...', 'action' : () => { this.$emit('reload'); } });
                }

                if ( this.$rc.$state.isAuthActorSystemAdmin() )
                {
                    el.actions.push({'text': 'Start deep (re)sync...', 'action': () => this.startDeepSync(settings)});
                }

                ret.push(el);
            }

            ret.sort((a, b) => (a.label > b.label) ? 1 : -1);

            return ret;
        },
    },
}
</script>

<style lang="scss" scoped>
.int-disabled
{
    color: rgba(0,0,0,0.3) !important;
}
.int-error
{
    color: red !important;
}
</style>
